import { keyframes } from "styled-components";
import styled from "styled-components";
import { Box, Flex } from "../../assets/ui";
import { color, maxWidth, bottom } from "styled-system";
import { Text } from "../../assets/ui";

export const SectionTitle = styled(Text)`
  font-size: 28px;
  line-height: 35px;
  font-weight: 600;
  ${color};
  ${maxWidth};

  @media (min-width: ${({ theme }) => theme.queries.md}) {
    font-weight: 600;
    font-size: 40px;
    line-height: 49px;
  }
`;

SectionTitle.defaultProps = {
  color: "#A5B3C7"
};
const hideTitle = keyframes`
  0% {
    opacity: 1;
    height: fit-content;
    display: flex;
  }
  100% {
    opacity: 0;
    height: 0;
    min-height: 0 !important;
    position: absolute;
    z-index: -22;
  }
`;
const showTitle = keyframes`
  0% {
    opacity: 0;
    height: 0;
    display: none;
  }
  100% {
    opacity: 1;
    display: flex;
    height: fit-content;
  }
`;

export const StyledIndicator = styled.div`
  width: 15px;
  height: 15px;

  @media (min-width: ${({ theme }) => theme.queries.sm}) {
    width: 25px;
    height: 25px;
  }
`;

export const StyledIndicatorWrapper = styled.div`
  width: fit-content;
  height: fit-content;
  position: absolute;
  ${bottom};
  left: 50%;
  transform: translateX(-50%);

  & > li:not(:last-child):before {
    content: "";
    width: 13px;
    height: 1px;
    background: #e3e3e3;
    position: absolute;
    left: 10px;
    top: 50%;
    border-radius: 2px;
    transform: translateY(-50%);
  }

  & > li {
    position: relative;
    border: 1px solid #d5d5d5;
    width: 8px;
    height: 8px;
    box-sizing: border-box;
    border-radius: 50%;
    margin: 0 10px;
  }

  & > .slick-active {
    background: ${({ theme }) => theme.colors.mainGreen};
    border-color: ${({ theme }) => theme.colors.mainGreen};
  }
`;

export const StyledSectionWrapper = styled(Flex)`
  flex-direction: column;
  background: url("./images/features-bg.png")
    ${({ theme }) => theme.colors.darkBlue};
  background-size: auto 100%;
  background-repeat: no-repeat;
  padding: 70px 24px;
  text-align: left;

  img {
    max-width: 100%;
    height: auto;
  }

  @media (min-width: ${({ theme }) => theme.queries.sm}) {
    img {
      margin-bottom: 0;
    }
  }

  @media (min-width: ${({ theme }) => theme.queries.md}) {
    padding-bottom: 0;
  }
`;

export const SectionContent = styled(Box)`
  @media (min-width: ${({ theme }) => theme.queries.sm}) {
    display: flex;
    //align-items: center;
    width: 100%;
    max-width: 1280px;
    margin: 0 auto;
  }

  @media (min-width: ${({ theme }) => theme.queries.md}) {
    align-items: flex-start;
    padding: 0 65px;
  }

  @media (min-width: ${({ theme }) => theme.queries.lg}) {
    margin-bottom: -80px;
  }
`;

export const FeatureType = styled(Box)`
  margin-top: 10px;

  @media (min-width: ${({ theme }) => theme.queries.sl}) {
    display: none;
  }
`;

export const TitleWrapper = styled(Box)`
  max-width: 1280px;
  margin: 0 auto;
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  flex-direction: column;
  width: 100%;
  opacity: 0;
  min-height: 200px;
  display: ${({ isActive, isOld }) => (isOld || isActive ? "flex" : "none")};
  overflow: hidden;
  animation-delay: ${({ isActive, isOld }) => (isActive ? "0.2s" : "0s")};
  animation-name: ${({ isActive, isOld }) =>
    isActive ? showTitle : isOld ? hideTitle : ""};
  animation-duration: ${({ isActive, isOld }) =>
    isActive ? "0.5s" : isOld ? "0.5s" : "0"};
  animation-fill-mode: forwards;

  @media (min-width: ${({ theme }) => theme.queries.sm}) {
    min-height: 180px;
  }

  @media (min-width: ${({ theme }) => theme.queries.md}) {
    padding: 0 65px;
  }
`;

export const SliderWrapper = styled(Box)`
  position: relative;

  @media (min-width: ${({ theme }) => theme.queries.sm}) {
    width: 50%;
    flex-grow: 1;

    & img {
      width: 100%;
      height: auto;
      max-width: 830px;
      max-height: 550px;
    }
  }

  @media (min-width: ${({ theme }) => theme.queries.md}) {
    padding-right: 9%;
  }
`;

export const OptionsList = styled(Box)`
  display: none;

  @media (min-width: ${({ theme }) => theme.queries.sl}) {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    width: 35%;
    max-width: 440px;
    padding-left: 20px;
  }

  @media (min-width: ${({ theme }) => theme.queries.md}) {
    //width: 50%;
  }
  @media (min-width: ${({ theme }) => theme.queries.lg}) {
    width: 50%;
    padding-left: 100px;
  }
`;

export const StyledOption = styled(Box)`
  font-weight: ${({ isCurrent }) => (isCurrent ? "600" : "normal")};
  font-size: ${({ isCurrent }) => (isCurrent ? "16px" : "14px")};
  line-height: 45px;
  cursor: pointer;
  position: relative;
  transition: 0.5s;

  & > svg {
    position: absolute;
    left: -30px;
    top: 50%;
    transition: 0.5s;
    transform: translateY(-50%);
  }

  @media (min-width: ${({ theme }) => theme.queries.md}) {
    line-height: 45px;
  }
`;

export const AdaptiveImage = styled.img.attrs(({ mobile, desktop, theme }) => {
  return {
    src:
      window.innerWidth > parseInt(theme.queries.sl, 10)
        ? `./images/${desktop}`
        : `./images/${mobile}`
  };
})``;

export const SlideImage = styled.img`
  width: 100%;
  height: auto;
`;

export const IphoneWrapper = styled.div`
  position: absolute;
  width: 28%;
  top: 0;
  margin-top: 21%;
  right: 0px;

  @media (min-width: ${({ theme }) => theme.queries.sm}) {
    & .iphone {
      padding: 7%;
    }
  }

  @media (min-width: ${({ theme }) => theme.queries.md}) {
    margin-top: 9%;
  }
`;
export const ImacWrapper = styled.div`
  position: relative;
  background: url("./images/imac-demo-list.png");
  background-repeat: no-repeat;
  background-size: 100% auto;
  padding: 1.1% 1% 26.5% 1.2%;

  & .mac-header {
    width: 10%;
    height: 40px;
    position: absolute;
    top: 0;
    left: 50%;
    margin-top: 0.5%;
    z-index: 1;
    transform: translateX(-50%);
    background: url("./images/1234.png");
    background-repeat: no-repeat;
    background-size: 100% auto;
  }
`;
